export const pushPageView = (data) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'pageview',
        ...data,
    });
};

export const pushUserLogin = (user) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        event: 'user_login',
        user_role: user.is_admin ? 'super_admin' : 'normal_user',
        user_email: user.email,
        company_id: user.company?.id,
    });
};

export const pushComponentView = (componentName, action = 'view') => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        event: 'component_event',
        component_name: componentName,
        action,
    });
};
